module.exports = __webpack_public_path__ + "html/my_account.1a0de0.html";


/*****************
 ** WEBPACK FOOTER
 ** /mnt/jenkins/jobs/master/workspace/core/client/common/User/my_account.html
 ** module id = 520
 ** module chunks = 0 1 2 3 5 11
 **/